import { createContext, useContext } from 'react';

interface PanelEditContextValue {
  onRunQuery: () => void;
  onRowFiltersAdded?: () => void;
}

const PanelEditContext = createContext<PanelEditContextValue | null>(null);

export function usePanelEditContext() {
  return useContext(PanelEditContext);
}

export default PanelEditContext;
